import {IntermediatePart} from "../../intermediatePart";
import DesignNavigationItem from "../../../../visComponents/designNavigationItem";
import Cabinet from "../../parts/cabinet";

export default class Microwave extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'microwave';
    this.partName = 'Microwave';
    this.translateId = "visualizer.kitchen.appliance.microwave";
  }

  load(dbFeature) {
    dbFeature.metaData.Appliance = ["Microwave"];
    return super.load_(dbFeature, new Microwave());
  }

  handleClick(ignoreLocked) {
    const parent = this.getParent();
    super.handleClick(ignoreLocked); // 1) set microwave

    const applianceParent = parent.getParent();
    const cabinetParent = applianceParent.layout.parts[Cabinet.id];
    if (cabinetParent && cabinetParent.topCabinet && cabinetParent.topCabinet.activeFeature
      && cabinetParent.getTopCabinetApplianceType() !== "Microwave") {
      const topCabinetConditions = cabinetParent.topCabinet.getArrayOfConditions();
      topCabinetConditions.push({
        propName: "Appliance",
        propValue: "Microwave"
      });
      const matchingCabinets = super.navigationSubItemsWithFilterMultipleConditions(
        topCabinetConditions,
        cabinetParent.topCabinet.features
      );
      if (matchingCabinets.length) {
        const currentName = cabinetParent.topCabinet.activeFeature.getSplittedFeatureName();
        const matchingCabinet = matchingCabinets.find(cabinet => {
          return cabinet.getSplittedFeatureName() === currentName
        });
        (matchingCabinet || matchingCabinets[0]).handleClick(ignoreLocked);
      }
    }

    if (cabinetParent && cabinetParent.topCabinet && cabinetParent.topCabinet.disabled && !this.disabled) {
      cabinetParent.topCabinet.disabled = this.disabled;
      cabinetParent.topCabinet.activeFeatureParts.forEach((activeFeaturePart) => {
        activeFeaturePart.disabled = this.disabled
      });
      const topHandle = cabinetParent.topHandle;
      if (topHandle) {
        topHandle.disabled = this.disabled;
      }
    }

    this.featureClicked();
  }

  navigationSubItems(filters, searchText) {
    const filteredAvailableFeatures = super.getFeaturesBySearchText(super.getFilteredFeaturesByFilters(filters), searchText);
    const featuresToDisplay = super.navigationSubItemsWithFilterMultipleConditions(this.getArrayOfConditions(true), filteredAvailableFeatures);
    return featuresToDisplay.map(_ => new DesignNavigationItem(_.featureName, _));
  }

  setLayers(layout) {

    const cabinetParent = this.getParent().layout.parts[Cabinet.id];
    const topCabinet = cabinetParent && cabinetParent.topCabinet;
    if (topCabinet && (topCabinet.disabled || !topCabinet.featureGroupEnabled)) {
      super.hideLayers();
      return
    }

    if (this.activeFeature && (this.activeFeature.matchesMetaForArrayOfConditions(this.getArrayOfConditions())
      || (this.activeFeature.notAvailableInVisualizer && this.placeholderFeature))) {
      super.setLayers(layout);
    } else {
      this.setDefault();
      super.setLayers(layout);
    }
  }

  getArrayOfConditions(ignoreAppliance) {
    return ignoreAppliance
      ? []
      : [{
        propName: "Appliance",
        propValue: this.getParent().layout.parts["Cabinet"].getTopCabinetApplianceType()
      }];
  }

  setZIndex(zIndexes) {
    if(zIndexes) {
      const zIndex = zIndexes.Appliances.Microwave;
      if (this.activeFeature) {
        this.activeFeature.layer.zIndex = zIndex;
      }
      if (this.placeholderFeature) {
        this.placeholderFeature.layer.zIndex = zIndex;
      }
    }
  }
}
